import { route, tag, type PageTour } from '../pageTour';

export const sitesTour: PageTour = {
  id: 'page-sites',
  version: 1,
  title: 'Sites',
  summary: 'Every site you can reach, whether it is online, and how to add a new one.',
  match: route('/sites'),
  steps: [
    {
      target: tag('dashboard-view-toggle'),
      title: 'List or cards',
      description: 'Switch between a compact list and a card for each site. Your choice is remembered.',
      side: 'bottom',
    },
    {
      target: tag('dashboard-register'),
      title: 'Register a site',
      description: 'Add a new site to the cloud. You get a Site ID and token to enter on the machine itself.',
      side: 'bottom',
      permission: 'nodes.register',
    },
    {
      target: tag('dashboard-status-filter'),
      title: 'Filter your sites',
      description: 'Show only online or offline sites. The column also lets you search, show sites that need attention, and change the sort order.',
      side: 'right',
    },
    {
      target: tag('dashboard-sites'),
      title: 'Your sites',
      description: 'Each site shows its status, cameras and active alerts. Click a site to open it.',
      side: 'top',
    },
  ],
};
